module.exports = "<div class=et-report-template-preview> <iframe-template path-url={{templateUrl}} css=100% key=reportTemplatePreview></iframe-template> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/system/settingcenter/reportTemplateSetting/view/reportTemplatePreview.html
// module id = BRHv
// module chunks = 0